import React from 'react';
import { NumericFormat } from 'react-number-format';
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function DealMinimumInvestmentField({
  value,
  error,
  setValue,
  setError,
}) {
  const handleChange = (values) => {
    setValue(values.floatValue);
  };
  return (
    <Box>
      <FormControl fullWidth>
        <NumericFormat
          value={value}
          prefix='$'
          onValueChange={handleChange}
          customInput={TextField}
          aria-describedby='minimum-investment-helper-text'
          label='Minimum Investment'
          id='minimum_investment'
          error={Boolean(error)}
          variant='standard'
          thousandSeparator=','
        />

        {error ? (
          <FormHelperText id='minimum-investment-helper-text'>
            {error}
          </FormHelperText>
        ) : (
          <FormHelperText id='minimum-investment-helper-text'>
            Enter the minimum investment amount.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
